var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { class: _vm.getClassName("cart-footer") }, [
    _vm.items.length > 0
      ? _c("dl", { class: _vm.getClassName("cart-footer__total") }, [
          _c("dt", { class: _vm.getClassName("cart-footer__term") }, [
            _vm._v("\n      商品合計"),
            _c("span", { class: _vm.getClassName("cart-footer__ruby") }, [
              _vm._v("(税込)")
            ])
          ]),
          _vm._v(" "),
          _c("dd", { class: _vm.getClassName("cart-footer__price") }, [
            _c("span", { class: _vm.getClassName("cart-footer__strong") }, [
              _vm._v(_vm._s(_vm.getTotal))
            ]),
            _vm._v("円\n    ")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { class: _vm.getClassName("cart-footer__box") }, [
      _vm.items.length > 0
        ? _c(
            "a",
            {
              class: _vm.getClassName("cart-footer__button--order"),
              attrs: { href: _vm.orderUrl }
            },
            [_vm._v("購入手続きへ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          class: _vm.getClassName("cart-footer__button--continue"),
          attrs: { href: "/items" }
        },
        [_vm._v("お買いものを続ける")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }